import React from 'react';

const EdgeGatewayPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/gateways',
			exact: true,
			component: React.lazy(() => import('./EdgeGatewayPage')),
		},
		{
			path: '/admin/gateways/download',
			exact: true,
			component: React.lazy(() => import('./EdgeGatewayDownloadPage')),
		},
		{
			path: '/admin/gateways/configure',
			exact: true,
			component: React.lazy(() => import('./ConfigureEdgeGatewayPage')),
		},
	],
};

export default EdgeGatewayPageConfig;
